import { NewTerminationNotice } from './schema';

/**
 * Apply small adjustments to the data, per Y-Säätiö's request. Kenno has certain requirements which
 * do not match Y-Säätiö's needs.
 *
 * Every beneficiary gets the same `returnPercentage`.
 *
 * `displaysSelf` is the same as `givingContactInfoAllowed`. Having these as separate values is not
 * realistic for Y-Säätiö's use case, but they are required by Kenno.
 *
 * `movingOutDate` is always the same as `endDate`. This is Y-Säätiö's rental processeses .
 */
export function getAdjustedTerminationFormData(data: NewTerminationNotice): NewTerminationNotice {
  if (data.beneficiaries.length === 0) {
    throw new Error('Beneficiaries required');
  }
  const returnPercentage = Math.round(100 / data.beneficiaries.length);
  return {
    ...data,
    displaysSelf: data.givingContactInfoAllowed,
    movingOutDate: data.endDate,
    beneficiaries: data.beneficiaries.map((ben) => ({ ...ben, returnPercentage })),
  };
}
